const Panorama = require('./Panorama.js').default

/*                                                                
                                                                                                                                          
EEEEEEEEEEEEEEEEEEEEEE                                        iiii  PPPPPPPPPPPPPPPPP                                                     
E::::::::::::::::::::E                                       i::::i P::::::::::::::::P                                                    
E::::::::::::::::::::E                                        iiii  P::::::PPPPPP:::::P                                                   
EE::::::EEEEEEEEE::::E                                              PP:::::P     P:::::P                                                  
  E:::::E       EEEEEE   qqqqqqqqq   qqqqquuuuuu    uuuuuu  iiiiiii   P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo   
  E:::::E               q:::::::::qqq::::qu::::u    u::::u  i:::::i   P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo 
  E::::::EEEEEEEEEE    q:::::::::::::::::qu::::u    u::::u   i::::i   P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o
  E:::::::::::::::E   q::::::qqqqq::::::qqu::::u    u::::u   i::::i   P:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o
  E:::::::::::::::E   q:::::q     q:::::q u::::u    u::::u   i::::i   P::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o
  E::::::EEEEEEEEEE   q:::::q     q:::::q u::::u    u::::u   i::::i   P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o
  E:::::E             q:::::q     q:::::q u::::u    u::::u   i::::i   P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o
  E:::::E       EEEEEEq::::::q    q:::::q u:::::uuuu:::::u   i::::i   P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o
EE::::::EEEEEEEE:::::Eq:::::::qqqqq:::::q u:::::::::::::::uui::::::iPP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::o
E::::::::::::::::::::E q::::::::::::::::q  u:::::::::::::::ui::::::iP::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::o
E::::::::::::::::::::E  qq::::::::::::::q   uu::::::::uu:::ui::::::iP::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo 
EEEEEEEEEEEEEEEEEEEEEE    qqqqqqqq::::::q     uuuuuuuu  uuuuiiiiiiiiPPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   
                                  q:::::q                                                                                                 
                                  q:::::q                                                                                                 
                                 q:::::::q                                                                                                
                                 q:::::::q                                                                                                
                                 q:::::::q                                                                                                
                                 qqqqqqqqq                                                                                                
*/
export default function EquiPanorama() {
    Panorama.apply(this, arguments)

    var scope = this,
        geo = new THREE.SphereGeometry(this.player.viewerWidth * 4, 32, 64),
        im = new Image(),
        texture = new THREE.Texture()

    im.crossOrigin = 'anonymous'
    im.addEventListener(
        'load',
        function() {
            scope.camera.refreshView()
            /**
             * This is to fix a bug ith iOS Safari where the image displays incorrectly
             * Current leading theory as to what causes this is subsampling - see: http://stackoverflow.com/questions/12554947/mobile-safari-renders-img-src-dataimage-jpegbase64-scaled-on-canvas
             * but still not sure why this would fix it. Perhaps it's related to the browser rendering the image internally and caching it
             *
             * Also note that bug only appeard in protrait mode
             */
            document
                .createElement('canvas')
                .getContext('2d')
                .drawImage(im, 0, 0)

            texture.image = im
            texture.needsUpdate = true
            scope.player.requestUpdate()
        },
        false
    )

    im.src = this.player.options.localMode.data

    var mat = new THREE.MeshBasicMaterial({
        map: texture,
        side: THREE.BackSide,
        overdraw: true,
    })

    var mesh = new THREE.Mesh(geo, mat)
    // mesh.receiveShadow = true

    mesh.scale.z = -1

    this.meshes.push(mesh)

    if (this.player.options.localMode.correction) {
        var pitch = (Math.PI * this.player.options.localMode.correction.pitch) / 180
        var roll = (Math.PI * this.player.options.localMode.correction.roll) / 180

        mesh.rotation.set(roll, 0, pitch)
    }

    this.element = CanvasManager.getCanvas()
    this.renderer = new THREE.WebGLRenderer({ antialias: true, canvas: this.element })
}
